import React, {FC, memo} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {NavLineTabsInterface} from '../../types'

const NavLine: FC<NavLineTabsInterface> = memo(({navTabs}) => {

    return (
        <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap">
            {
                navTabs.map((tab, index) => (
                    <li className="nav-item" key={index}>
                        <a
                            className={`nav-link text-active-primary me-6 ${index === 0 ? 'active' : ''}`}
                            data-bs-toggle="tab"
                            href={`#kt_${tab.href}`}
                        >
                            <div className="d-flex justify-content-center align-items-center">
                                {tab.iconPath && (
                                    <span className="menu-icon">
                                        <KTSVG path={toAbsoluteUrl(`/media/icons/duotune/${tab.iconPath}.svg`)}
                                               className="svg-icon-1" />
                                    </span>
                                )}
                                <span
                                    className="d-flex justify-content-center align-items-center mx-1">{tab.label}</span>
                            </div>
                        </a>
                    </li>
                ))
            }
        </ul>
    )
})

export {NavLine}